<template>
  <div class="min-h-screen bg-gray-50">
    <!-- Если это страница доктора, используем DoctorLayout -->
    <DoctorLayout v-if="isDoctorPage">
    <router-view />
    </DoctorLayout>
    
    <!-- Если это страница медсестры, используем NurseLayout -->
    <NurseLayout v-else-if="isNursePage">
    <router-view />
    </NurseLayout>
    
    <!-- Для остальных страниц отображаем напрямую -->
    <router-view v-else />
    
    <!-- Модальное окно согласия (показывается только для авторизованных) -->
    <ConsentModal v-if="userType && !$route.meta.partnerEmbed" />
  </div>
</template>

<script>
import DoctorLayout from './components/DoctorLayout.vue'
import NurseLayout from './components/NurseLayout.vue'
import ConsentModal from './components/ConsentModal.vue'
import sessionBootstrap from './state/sessionBootstrap'

export default {
  name: 'App',
  components: {
    DoctorLayout,
    NurseLayout,
    ConsentModal
  },
  computed: {
    userType() {
      return sessionBootstrap.userType
    },
    staffRole() {
      return sessionBootstrap.staffRole
    },
    userTypeLoaded() {
      return sessionBootstrap.ready
    },
    isDoctorPage() {
      if (this.$route.meta.standalone) return false
      // Если тип пользователя еще не загружен, не показываем layout
      if (!this.userTypeLoaded) return false
      
      // Для главной страницы проверяем тип пользователя
      if (this.$route.path === '/' && this.userType === 'doctor') {
        return true
      }

      // Для менеджера клиники используем тот же layout, что и у врача
      if (
        this.userType === 'staff' &&
        this.staffRole === 'clinic_manager' &&
        this.$route.path.startsWith('/clinic-')
      ) {
        return true
      }
      
      // Определяем, является ли текущая страница частью панели доктора
      const doctorRoutes = ['/doctor-schedule', '/patients', '/ultrasound', '/appointments', '/profile', '/certificate', '/organization-patients', '/correctional-institutions', '/psychological-monitoring', '/detected-faces', '/clinic-today', '/clinic-appointments', '/clinic-schedule', '/clinic-finance', '/clinic-settings']
      return doctorRoutes.includes(this.$route.path) || 
             this.$route.path.startsWith('/support') ||
             this.$route.path.startsWith('/patients/')
    },
    isNursePage() {
      if (this.$route.meta.standalone) return false
      // Если тип пользователя еще не загружен, не показываем layout
      if (!this.userTypeLoaded) return false
      
      // Для главной страницы проверяем тип пользователя
      if (this.$route.path === '/' && this.userType === 'nurse') {
        return true
      }
      
      // Определяем, является ли текущая страница частью панели медсестры
      const nurseRoutes = ['/nurse-calls-history', '/patients', '/profile', '/certificate']
      return nurseRoutes.includes(this.$route.path) || 
             this.$route.path.startsWith('/patients/')
    }
  },
  watch: {
    $route() {}
  }
}
</script> 

<style>
/* Removed page transition styles */
</style> 
